module.exports = __webpack_public_path__ + "img/icon-email.a75cb307.svg";